import styled from 'styled-components';
import { spacing } from 'ui/theme';
import { FilterColumnsDropdown } from './FilterColumnsDropdown';
import { useSegmentationQueryContext } from '../../../contexts/segmentationQuery';

const UsersTableActionsWrapper = styled.div`
  display: flex;
  gap: ${spacing.half};
`;

export const testIds = {
  actions: 'segmentation-users-table-actions',
};

export const UsersTableActions = () => {
  const { results } = useSegmentationQueryContext();
  const shouldShow = !!results?.length;
  return (
    <>
      {shouldShow && (
        <UsersTableActionsWrapper data-test={testIds.actions}>
          <FilterColumnsDropdown />
        </UsersTableActionsWrapper>
      )}
    </>
  );
};
